module.exports = __webpack_public_path__ + "media/images/flags/gg-b08bf45086219fdac05cacaa0b036943.svg";